module.exports = __webpack_public_path__ + "static/media/calendar-blue.b57d7298.svg";